import React from 'react';
import GridView from '../../../../Components/Store/GridView.js';
import { useQuery } from '@apollo/client';
import { productQueries } from '../../../../graphql/queries';
import { useTranslation } from 'react-i18next';
import PageTitle from '../../../../Components/PageTitle.js';
import GridViewSkeleton from '../../../../Components/Skeletons/GridViewSkeleton.js';

const GiftVouchers = () => {
  const { data, loading } = useQuery(productQueries.GiftVoucherProducts);
  const { t } = useTranslation();

  return (
    <>
      <PageTitle title={t('gift-vouchers')} />
      {
        (loading || !data) ?
          (<GridViewSkeleton nowrap />) :
          (
            <GridView
              products={data.giftVoucherProducts}
            />
          )
      }
    </>
  );
};

export default GiftVouchers;
